import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createTextVNode as _createTextVNode, renderList as _renderList, vModelCheckbox as _vModelCheckbox, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, withKeys as _withKeys, vShow as _vShow, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar crm-board-bar" }
const _hoisted_3 = {
  class: "page-bar-main",
  style: {"display":"flex","align-items":"center","gap":"8px"}
}
const _hoisted_4 = {
  key: 0,
  style: {"font-size":"24px","font-weight":"bold"}
}
const _hoisted_5 = ["title"]
const _hoisted_6 = { class: "pb-actions" }
const _hoisted_7 = {
  style: {"fill":"currentColor","stroke":"none","width":"14px","height":"14px"},
  "aria-hidden": "true",
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  "fill-rule": "evenodd"
}
const _hoisted_8 = { class: "pb-more" }
const _hoisted_9 = ["aria-expanded"]
const _hoisted_10 = { class: "bracing-rental" }
const _hoisted_11 = { class: "page-filters pf-bar" }
const _hoisted_12 = { class: "pf-search" }
const _hoisted_13 = { class: "crm-board-filter-tags" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "board-item-tags"
}
const _hoisted_16 = { style: {"display":"flex","margin-bottom":"10px","gap":"10px"} }
const _hoisted_17 = { class: "board-item-tags-tags" }
const _hoisted_18 = ["onUpdate:modelValue"]
const _hoisted_19 = { style: {"margin-left":"0"} }
const _hoisted_20 = {
  key: 0,
  class: "crm-board-edit-panel"
}
const _hoisted_21 = { class: "crm-board-color-select" }
const _hoisted_22 = ["value"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "crm-board-edit-actions" }
const _hoisted_25 = { class: "kanban board-mobile-cols" }
const _hoisted_26 = { class: "kanban-colh" }
const _hoisted_27 = ["onUpdate:modelValue", "onChange", "onBlur", "onKeyup"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = { class: "kanban-colcnt" }
const _hoisted_31 = { class: "kanban-colb" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = { class: "crm-board-item-body" }
const _hoisted_34 = ["onUpdate:modelValue", "onChange"]
const _hoisted_35 = { class: "customer-request-tags" }
const _hoisted_36 = { class: "customer-request-tags crm-extra-tags" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = { key: 2 }
const _hoisted_39 = { key: 3 }
const _hoisted_40 = ["title"]
const _hoisted_41 = ["title"]
const _hoisted_42 = {
  key: 0,
  title: "Milestones done"
}
const _hoisted_43 = ["title"]
const _hoisted_44 = ["title"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 0,
  class: "board-activity"
}
const _hoisted_48 = { class: "form-close" }
const _hoisted_49 = { class: "board-activity-tabs" }
const _hoisted_50 = {
  key: 0,
  class: "board-activity-list"
}
const _hoisted_51 = { class: "board-activity-date" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = {
  key: 1,
  class: "board-activity-list"
}
const _hoisted_54 = { class: "board-activity-date" }
const _hoisted_55 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_edit_columns_panel = _resolveComponent("edit-columns-panel")!
  const _component_inbox_panel = _resolveComponent("inbox-panel")!
  const _component_forge_daily_digest = _resolveComponent("forge-daily-digest")!
  const _component_forge_team = _resolveComponent("forge-team")!
  const _component_add_new_company_board_item = _resolveComponent("add-new-company-board-item")!
  const _component_add_edit_company_board_item = _resolveComponent("add-edit-company-board-item")!
  const _component_add_edit_meeting_item = _resolveComponent("add-edit-meeting-item")!
  const _component_move_column_prompt = _resolveComponent("move-column-prompt")!
  const _component_deck_settings_modal = _resolveComponent("deck-settings-modal")!
  const _component_confirm_delete = _resolveComponent("confirm-delete")!
  const _component_select_employees = _resolveComponent("select-employees")!
  const _component_pdf_pop_up = _resolveComponent("pdf-pop-up")!
  const _component_rock_modal = _resolveComponent("rock-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[54] || (_cache[54] = _createElementVNode("div", { class: "page-bar-sub" }, "Work", -1)),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.isTaskManager)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.formData.name), 1))
            : _withDirectives((_openBlock(), _createElementBlock("textarea", {
                key: 1,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.name) = $event)),
                onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.saveBoardData(true))),
                style: {"background":"none","border":"none","padding":"0","color":"white","font-size":"24px","font-weight":"bold","margin":"0","height":"auto","width":"auto","field-sizing":"content","min-inline-size":"20px","max-width":"100%"}
              }, null, 544)), [
                [_vModelText, _ctx.formData.name]
              ]),
          (_ctx.formData.slug)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                type: "button",
                class: _normalizeClass(_ctx.isFavorite ? 'page-bar-fav on' : 'page-bar-fav'),
                title: _ctx.isFavorite ? 'Remove from favorites' : 'Add to favorites',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleFavorite()))
              }, [
                _createVNode(_component_svg_icon, {
                  icon: _ctx.isFavorite ? 'starfilled' : 'star'
                }, null, 8, ["icon"])
              ], 10, _hoisted_5))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-light pb-btn hide-mobile-991",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.back()))
        }, "Back"),
        _createElementVNode("button", {
          type: "button",
          class: "ai-btn pb-btn pb-forge",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.openDigest()))
        }, [
          (_openBlock(), _createElementBlock("svg", _hoisted_7, [...(_cache[55] || (_cache[55] = [
            _createElementVNode("path", { d: "M12 23c-4.4 0-8-3.1-8-7.5 0-3.3 2-5.6 3.6-7.4.4-.4 1.1-.1 1.1.5 0 1.3.6 2.6 1.6 3.2C10.1 7.7 11.6 4 15 1.2c.4-.3 1 0 1 .5-.1 2.6.9 4.5 2.2 6.4C19.3 9.8 20 11.6 20 15.5 20 19.9 16.4 23 12 23zm0-2c1.9 0 3.3-1.3 3.3-3.1 0-1.6-.9-2.7-2.1-3.9-.3-.3-.8-.1-.8.3-.1 1-.6 1.8-1.3 2.2-.1-1.1-.5-2-1.1-2.6-.3-.3-.8-.1-.8.3-.3 1.3-1.5 2.2-1.5 3.7C7.7 19.7 9.8 21 12 21z" }, null, -1)
          ]))])),
          _cache[56] || (_cache[56] = _createElementVNode("span", null, "The Daily Digest", -1))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn-light pb-btn hide-mobile-991",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getActivity()))
        }, "Activity"),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "pb-kebab",
            "aria-haspopup": "menu",
            "aria-expanded": _ctx.showOptionsMenu,
            "aria-label": "Board options",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showOptionsMenu = !_ctx.showOptionsMenu))
          }, [
            _createVNode(_component_svg_icon, { icon: "dots" })
          ], 8, _hoisted_9),
          (_ctx.showOptionsMenu)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "pb-menu",
                role: "menu",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showOptionsMenu = false))
              }, [
                _createElementVNode("button", {
                  type: "button",
                  class: "pb-mi mobile-991",
                  role: "menuitem",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getActivity()))
                }, "Activity"),
                _createElementVNode("button", {
                  type: "button",
                  class: "pb-mi",
                  role: "menuitem",
                  onClick: _cache[8] || (_cache[8] = () => { _ctx.editTags = !_ctx.editTags; _ctx.editColumns = false; })
                }, _toDisplayString(_ctx.editTags ? 'Hide Tags' : 'Edit Tags'), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "pb-mi",
                  role: "menuitem",
                  onClick: _cache[9] || (_cache[9] = () => { _ctx.editColumns = !_ctx.editColumns; _ctx.editTags = false; })
                }, _toDisplayString(_ctx.editColumns ? 'Hide Columns' : 'Edit Columns'), 1),
                (_ctx.canEditUsers)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "pb-mi",
                      role: "menuitem",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.editUsers()))
                    }, "Edit Users"))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  class: "pb-mi",
                  role: "menuitem",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showSettings = true))
                }, "Settings"),
                (_ctx.canDelete)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _cache[57] || (_cache[57] = _createElementVNode("div", { class: "pb-sep" }, null, -1)),
                      _createElementVNode("button", {
                        type: "button",
                        class: "pb-mi pb-mi-danger",
                        role: "menuitem",
                        onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showConfirmDeleteBoard = true))
                      }, "Delete Deck")
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[58] || (_cache[58] = _createElementVNode("svg", {
              viewBox: "0 0 24 24",
              "aria-hidden": "true"
            }, [
              _createElementVNode("circle", {
                cx: "11",
                cy: "11",
                r: "7"
              }),
              _createElementVNode("path", { d: "M21 21l-4.35-4.35" })
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.searchQ) = $event)),
              placeholder: "Search by name",
              "aria-label": "Search by name",
              onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.search()))
            }, null, 544), [
              [_vModelText, _ctx.searchQ]
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(_ctx.filteredTagCount ? 'crm-board-filter-btn on' : 'crm-board-filter-btn'),
              onClick: _cache[16] || (_cache[16] = () => { _ctx.showSelectTags = !_ctx.showSelectTags })
            }, [
              _cache[59] || (_cache[59] = _createTextVNode(" Filter Tags", -1)),
              (_ctx.filteredTagCount)
                ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (" + _toDisplayString(_ctx.filteredTagCount) + ")", 1))
                : _createCommentVNode("", true)
            ], 2),
            (_ctx.showSelectTags)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", {
                      onClick: _cache[17] || (_cache[17] = () => { _ctx.showSelectTags = false; _ctx.search(); }),
                      class: "btn",
                      style: {"margin":"0"}
                    }, "Save"),
                    _createElementVNode("div", {
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.clearFilterTags())),
                      class: "btn-light",
                      style: {"margin":"0"}
                    }, "Clear")
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.tags, (tag, i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: i,
                        class: "checkbox-input customer-request-tag",
                        style: _normalizeStyle('font-size:14px;background:'+tag.color)
                      }, [
                        _withDirectives(_createElementVNode("input", {
                          style: {"margin-left":"10px"},
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((tag.filterSelected) = $event)
                        }, null, 8, _hoisted_18), [
                          [_vModelCheckbox, tag.filterSelected]
                        ]),
                        _createElementVNode("span", _hoisted_19, _toDisplayString(tag.name), 1)
                      ], 4))
                    }), 128))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _cache[60] || (_cache[60] = _createElementVNode("span", { class: "pf-spacer" }, null, -1)),
          _createElementVNode("div", {
            onClick: _cache[19] || (_cache[19] = () => { _ctx.showScorecard = true }),
            class: "btn"
          }, "Scorecard"),
          _createElementVNode("div", {
            onClick: _cache[20] || (_cache[20] = () => { _ctx.showRocks = true }),
            class: "btn"
          }, "Rocks"),
          _createElementVNode("div", {
            onClick: _cache[21] || (_cache[21] = () => { _ctx.showGoals = true }),
            class: "btn"
          }, "Personal Goals")
        ]),
        (_ctx.editTags)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _cache[63] || (_cache[63] = _createElementVNode("div", { class: "crm-board-edit-title" }, [
                _createTextVNode("Tags"),
                _createElementVNode("span", null, "Drag to reorder")
              ], -1)),
              _createElementVNode("form", {
                class: "crm-board-edit-add",
                onSubmit: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.addTag()), ["prevent"]))
              }, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Tag name",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.addTagName) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.addTagName]
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.addTagColor) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$store.state.colorPalette, (color, i) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: i,
                        value: color.hex
                      }, _toDisplayString(color.label), 9, _hoisted_22))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.addTagColor]
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "color",
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.addTagColor) = $event)),
                    title: "Custom color"
                  }, null, 512), [
                    [_vModelText, _ctx.addTagColor]
                  ])
                ]),
                _cache[61] || (_cache[61] = _createElementVNode("button", { class: "add-btn" }, "Add", -1))
              ], 32),
              _createVNode(_component_draggable, {
                modelValue: _ctx.formData.tags,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.formData.tags) = $event)),
                class: "crm-board-edit-chips crm-board-edit-chips-tags"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.tags, (tag, i) => {
                    return (_openBlock(), _createElementBlock("div", {
                      style: _normalizeStyle('background:'+tag.color),
                      key: i
                    }, [
                      _createElementVNode("span", null, _toDisplayString(tag.name), 1),
                      _createElementVNode("span", {
                        class: "crm-board-edit-chip-x",
                        title: "Remove",
                        onClick: ($event: any) => (_ctx.removeTag(i))
                      }, [...(_cache[62] || (_cache[62] = [
                        _createElementVNode("svg", {
                          viewBox: "0 0 24 24",
                          xmlns: "http://www.w3.org/2000/svg"
                        }, [
                          _createElementVNode("path", { d: "m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z" })
                        ], -1)
                      ]))], 8, _hoisted_23)
                    ], 4))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.saveBoardData(false)))
                }, "Save"),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-light",
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.cancelBoardEdit()))
                }, "Cancel")
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.editColumns)
          ? (_openBlock(), _createBlock(_component_edit_columns_panel, {
              key: 1,
              columns: _ctx.formData.columns,
              hint: _ctx.isTaskManager ? 'items sent from meetings land in the first column' : '',
              onSave: _cache[29] || (_cache[29] = ($event: any) => (_ctx.saveBoardData(false))),
              onCancel: _cache[30] || (_cache[30] = ($event: any) => (_ctx.cancelBoardEdit())),
              onRemove: _ctx.removeCol,
              onAdd: _cache[31] || (_cache[31] = (col) => _ctx.formData.columns.push(col))
            }, null, 8, ["columns", "hint", "onRemove"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["crm-board-mobile-arrow crm-board-mobile-arrow-left mobile-767", _ctx.mobileColIndex <= 0 ? 'disabled' : '']),
          onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.mobilePrevCol()))
        }, [...(_cache[64] || (_cache[64] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", { d: "M15.41 7.41l-1.41-1.41-6 6 6 6 1.41-1.41-4.58-4.59z" })
          ], -1)
        ]))], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["crm-board-mobile-arrow crm-board-mobile-arrow-right mobile-767", _ctx.mobileColIndex >= _ctx.mobileColumnKeys.length - 1 ? 'disabled' : '']),
          onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.mobileNextCol()))
        }, [...(_cache[65] || (_cache[65] = [
          _createElementVNode("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "20",
            height: "20",
            viewBox: "0 0 24 24"
          }, [
            _createElementVNode("path", { d: "M8.59 16.59l1.41 1.41 6-6-6-6-1.41 1.41 4.58 4.59z" })
          ], -1)
        ]))], 2),
        _createElementVNode("div", _hoisted_25, [
          (_ctx.inboxShown)
            ? (_openBlock(), _createBlock(_component_inbox_panel, {
                key: 0,
                ref: "inboxPanel",
                class: _normalizeClass(_ctx.activeMobileColumn === _ctx.INBOX_COL ? 'crm-board-col-active' : ''),
                slug: _ctx.formData.slug,
                "show-rocks": _ctx.isMyTaskManager,
                onMoved: _cache[34] || (_cache[34] = ($event: any) => (_ctx.loadItems(false))),
                onOpen: _ctx.openInboxCard,
                onOpenRock: _ctx.openInboxRock
              }, null, 8, ["class", "slug", "show-rocks", "onOpen", "onOpenRock"]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.columns, (col, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (col.show)
                ? (_openBlock(), _createElementBlock("div", {
                    key: i,
                    class: _normalizeClass(["kanban-col kanban-col-tinted", col.name === _ctx.activeMobileColumn ? 'crm-board-col-active' : '']),
                    style: _normalizeStyle({ '--col-color': col.color })
                  }, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("span", {
                        class: "kanban-coldot",
                        style: _normalizeStyle({ background: col.color })
                      }, null, 4),
                      (col.showEdit)
                        ? _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 0,
                            class: "crm-board-col-rename",
                            type: "text",
                            "onUpdate:modelValue": ($event: any) => ((col.editInput) = $event),
                            onChange: ($event: any) => (_ctx.submitEditColName(col)),
                            onBlur: () => { col.showEdit = false },
                            onKeyup: _withKeys(() => { col.showEdit = false }, ["esc"]),
                            ref_for: true,
                            ref: 'colRename' + i
                          }, null, 40, _hoisted_27)), [
                            [_vModelText, col.editInput]
                          ])
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "crm-board-col-name",
                            title: "Click to rename",
                            onClick: ($event: any) => (_ctx.editColName(col, i))
                          }, _toDisplayString(col.name), 9, _hoisted_28)),
                      _createElementVNode("span", {
                        class: "kanban-coladd",
                        title: "Add card",
                        onClick: ($event: any) => (_ctx.addEditItem(col.name, null))
                      }, [
                        _createVNode(_component_svg_icon, { icon: "plus" })
                      ], 8, _hoisted_29),
                      _createElementVNode("span", _hoisted_30, _toDisplayString((_ctx.itemsByColumn[col.name] || []).length), 1),
                      _createVNode(_component_svg_icon, {
                        icon: "arrowsin",
                        class: "kanban-colcollapse",
                        onClick: () => { col.show = false }
                      }, null, 8, ["onClick"])
                    ]),
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_draggable, {
                        class: "crm-board-cards",
                        list: _ctx.itemsByColumn[col.name],
                        group: "column",
                        onChange: ($event: any) => (_ctx.dragEnd($event, col.name)),
                        animation: 150,
                        "ghost-class": "kanban-ghost",
                        "empty-insert-threshold": 40,
                        "force-auto-scroll-fallback": true,
                        "scroll-sensitivity": 120,
                        "scroll-speed": 20,
                        delay: 200,
                        "delay-on-touch-only": true,
                        "touch-start-threshold": 5
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsByColumn[col.name], (item) => {
                            return _withDirectives((_openBlock(), _createElementBlock("div", {
                              key: (item.InboxItem ? 'inbox' : item.RockRow ? 'rock' : '') + item.ID,
                              class: _normalizeClass(["crm-board-card", item.Overdue ? 'crm-board-item-overdue' : '']),
                              onClick: ($event: any) => (_ctx.addEditItem(null, item, $event))
                            }, [
                              (item.CardColor)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: "item-card-color-cover",
                                    style: _normalizeStyle('background:'+item.CardColor)
                                  }, null, 4))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_33, [
                                _createElementVNode("h3", null, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    "onUpdate:modelValue": ($event: any) => ((item.Checked) = $event),
                                    onChange: ($event: any) => (item.MeetingItem ? _ctx.meetingItemCompleteChange(item) : _ctx.itemChange(item))
                                  }, null, 40, _hoisted_34), [
                                    [_vModelCheckbox, item.Checked]
                                  ]),
                                  _createTextVNode(_toDisplayString(item.Name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_35, [
                                  (item.PriorityTag)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        style: _normalizeStyle('background:'+item.PriorityTag.color)
                                      }, _toDisplayString(item.PriorityTag.name), 5))
                                    : _createCommentVNode("", true),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.TagsJSON, (tag, k) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: k,
                                      style: _normalizeStyle('background:'+_ctx.tagColor(item, tag))
                                    }, _toDisplayString(tag), 5))
                                  }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_36, [
                                  (item.DateDisplay)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 0,
                                        class: _normalizeClass(item.Overdue ? 'crm-extra-tag-overdue' : 'crm-extra-tag-date')
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "clock" }),
                                        _createTextVNode(_toDisplayString(item.DateDisplay), 1)
                                      ], 2))
                                    : _createCommentVNode("", true),
                                  (item.CommentCount != '0')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                        _createVNode(_component_svg_icon, { icon: "comment" }),
                                        _createTextVNode(_toDisplayString(item.CommentCount), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (item.FileCount != '0')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createVNode(_component_svg_icon, { icon: "paperclip" }),
                                        _createTextVNode(_toDisplayString(item.FileCount), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (item.TotalChecklistItems)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                        _createVNode(_component_svg_icon, { icon: "checkbox" }),
                                        _createTextVNode(_toDisplayString(item.CheckedChecklistItems) + " / " + _toDisplayString(item.TotalChecklistItems), 1)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (item.MeetingName)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 4,
                                        title: 'From meeting: ' + item.MeetingName
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "twousers" }),
                                        _createTextVNode(_toDisplayString(item.MeetingName), 1)
                                      ], 8, _hoisted_40))
                                    : _createCommentVNode("", true),
                                  (item.Rock)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["crm-rock-st", _ctx.rockStatus(item.Rock.Status).cls]),
                                          title: 'Rock · ' + _ctx.quarterLabel(item.Rock.Quarter)
                                        }, [
                                          _createVNode(_component_svg_icon, { icon: "star" }),
                                          _createTextVNode(_toDisplayString(_ctx.rockStatus(item.Rock.Status).label), 1)
                                        ], 10, _hoisted_41),
                                        (item.Rock.MilestoneCount)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                              _createVNode(_component_svg_icon, { icon: "checkbox" }),
                                              _createTextVNode(_toDisplayString(item.Rock.MilestonesDone) + " / " + _toDisplayString(item.Rock.MilestoneCount), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    : _createCommentVNode("", true),
                                  (item.HomeBoard)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 6,
                                        title: 'Mirrored from ' + item.HomeBoard.Name
                                      }, [
                                        _createVNode(_component_svg_icon, { icon: "copy" }),
                                        _createTextVNode(_toDisplayString(item.HomeBoard.Name), 1)
                                      ], 8, _hoisted_43))
                                    : (item.MirrorBoards.length)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 7,
                                          title: 'Also on ' + _ctx.boardNames(item.MirrorBoards)
                                        }, [
                                          _createVNode(_component_svg_icon, { icon: "copy" }),
                                          _createTextVNode(_toDisplayString(item.MirrorBoards.length), 1)
                                        ], 8, _hoisted_44))
                                      : _createCommentVNode("", true)
                                ])
                              ])
                            ], 10, _hoisted_32)), [
                              [_vShow, !item.hide]
                            ])
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["list", "onChange"]),
                      _createElementVNode("span", {
                        class: "kanban-addbtn",
                        onClick: ($event: any) => (_ctx.addEditItem(col.name, null))
                      }, "+ Add card", 8, _hoisted_45)
                    ])
                  ], 6))
                : (_openBlock(), _createElementBlock("div", {
                    class: "kanban-col kanban-col-collapsed kanban-col-tinted",
                    onClick: () => { col.show = true },
                    key: 'a'+i,
                    style: _normalizeStyle({ '--col-color': col.color })
                  }, [
                    _createVNode(_component_svg_icon, {
                      icon: "arrowsout",
                      class: "kanban-colcollapse"
                    }),
                    _createElementVNode("span", null, _toDisplayString(col.name), 1)
                  ], 12, _hoisted_46))
            ], 64))
          }), 256))
        ])
      ])
    ], 2),
    (_ctx.showActivity)
      ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
          _createElementVNode("div", _hoisted_48, [
            _createElementVNode("button", {
              type: "button",
              class: "form-close-x",
              title: "Close",
              onClick: _cache[35] || (_cache[35] = () => { _ctx.showActivity = false })
            }, "×")
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", {
              onClick: _cache[36] || (_cache[36] = () => { _ctx.showActivityGroup = 'Details' }),
              class: _normalizeClass(_ctx.showActivityGroup == 'Details' ? 'on' : '')
            }, "Details", 2),
            _createElementVNode("div", {
              onClick: _cache[37] || (_cache[37] = () => { _ctx.showActivityGroup = 'Cards' }),
              class: _normalizeClass(_ctx.showActivityGroup == 'Cards' ? 'on' : '')
            }, "Cards", 2)
          ]),
          (_ctx.showActivityGroup == 'Details')
            ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activity, (a, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("div", _hoisted_51, _toDisplayString(a.DateDisplay), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("b", null, _toDisplayString(a.Username), 1),
                      _createTextVNode(" " + _toDisplayString(a.Text) + " ", 1),
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => (_ctx.addEditItemFromID(a.CardID)), ["prevent"])
                      }, _toDisplayString(a.CardName), 9, _hoisted_52)
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityCards, (a, i) => {
                  return (_openBlock(), _createElementBlock("div", { key: i }, [
                    _createElementVNode("div", _hoisted_54, _toDisplayString(a.DateDisplay), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("a", {
                        onClick: _withModifiers(($event: any) => (_ctx.addEditItemFromID(a.CardID)), ["prevent"])
                      }, _toDisplayString(a.CardName), 9, _hoisted_55)
                    ])
                  ]))
                }), 128))
              ]))
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_resolveDynamicComponent('style'), null, {
      default: _withCtx(() => [...(_cache[66] || (_cache[66] = [
        _createTextVNode(" @media(max-width: 767px) { #pb-widget-btn, .af-launch { display: none !important; } } ", -1)
      ]))]),
      _: 1
    })),
    (_ctx.formData.slug)
      ? (_openBlock(), _createBlock(_component_forge_daily_digest, {
          key: 1,
          ref: "digest",
          "button-mode": "",
          "board-actions": "",
          onForge: _cache[38] || (_cache[38] = ($event: any) => (_ctx.openForge($event)))
        }, null, 512))
      : _createCommentVNode("", true),
    (_ctx.showForge)
      ? (_openBlock(), _createBlock(_component_forge_team, {
          key: 2,
          modal: "",
          only: [ 'tidyboard', 'planweek', 'sortinbox' ],
          "start-kind": _ctx.forgeKind,
          board: _ctx.forgeBoard,
          onApplied: _cache[39] || (_cache[39] = ($event: any) => (_ctx.forgeApplied())),
          onClose: _cache[40] || (_cache[40] = ($event: any) => (_ctx.showForge = false))
        }, null, 8, ["start-kind", "board"]))
      : _createCommentVNode("", true),
    (_ctx.showAddNewItem)
      ? (_openBlock(), _createBlock(_component_add_new_company_board_item, {
          key: 3,
          item: _ctx.addEditData,
          tags: _ctx.formData.tags,
          onClose: _ctx.closeAddNew
        }, null, 8, ["item", "tags", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showAddEditItem)
      ? (_openBlock(), _createBlock(_component_add_edit_company_board_item, {
          key: 4,
          item: _ctx.addEditData,
          tags: _ctx.addEditData.HomeTags || (_ctx.inboxCard ? _ctx.inboxCard.tags : _ctx.formData.tags),
          columns: _ctx.inboxCard ? _ctx.inboxCard.columns : _ctx.formData.columns,
          "default-move-slug": _ctx.inboxCard ? _ctx.formData.slug : null,
          onClose: _cache[41] || (_cache[41] = ($event: any) => (_ctx.closeAddEdit()))
        }, null, 8, ["item", "tags", "columns", "default-move-slug"]))
      : _createCommentVNode("", true),
    (_ctx.meetingItemCard)
      ? (_openBlock(), _createBlock(_component_add_edit_meeting_item, {
          key: 5,
          item: _ctx.meetingItemCard.MeetingItem,
          employees: _ctx.meetingItemAssignees,
          "from-meeting": { Name: _ctx.meetingItemCard.MeetingName, CanOpen: _ctx.meetingItemCard.CanOpenMeeting },
          onClose: _cache[42] || (_cache[42] = ($event: any) => (_ctx.closeMeetingItem()))
        }, null, 8, ["item", "employees", "from-meeting"]))
      : _createCommentVNode("", true),
    (_ctx.completedMove)
      ? (_openBlock(), _createBlock(_component_move_column_prompt, {
          key: 6,
          message: "Marked completed.",
          noun: "card",
          board: "deck",
          columns: _ctx.columnNames,
          current: _ctx.completedMove.current,
          "default-column": _ctx.completedMove.column,
          onMove: _cache[43] || (_cache[43] = ($event: any) => {_ctx.moveItemToColumn(_ctx.completedMove.itemID, $event); _ctx.completedMove = null}),
          onCancel: _cache[44] || (_cache[44] = ($event: any) => (_ctx.completedMove = null))
        }, null, 8, ["columns", "current", "default-column"]))
      : _createCommentVNode("", true),
    (_ctx.showSettings)
      ? (_openBlock(), _createBlock(_component_deck_settings_modal, {
          key: 7,
          slug: _ctx.formData.slug,
          columns: _ctx.columnNames,
          "complete-action": _ctx.completeAction,
          "complete-column": _ctx.completeColumn,
          onSaved: _ctx.settingsSaved,
          onClose: _cache[45] || (_cache[45] = ($event: any) => (_ctx.showSettings = false))
        }, null, 8, ["slug", "columns", "complete-action", "complete-column", "onSaved"]))
      : _createCommentVNode("", true),
    (_ctx.showConfirmDeleteBoard)
      ? (_openBlock(), _createBlock(_component_confirm_delete, {
          key: 8,
          onConfirm: _cache[46] || (_cache[46] = ($event: any) => (_ctx.deleteBoard())),
          onCancel: _cache[47] || (_cache[47] = ($event: any) => (_ctx.showConfirmDeleteBoard = false)),
          msg: "Delete this deck and all of its cards? Its cards also come off any other decks they are mirrored onto."
        }))
      : _createCommentVNode("", true),
    (_ctx.showEditUsers)
      ? (_openBlock(), _createBlock(_component_select_employees, {
          key: 9,
          title: "Share with",
          source: "/api/employees/picker",
          selectedIds: _ctx.editUsersCurrent,
          lockedIds: _ctx.editUsersLocked,
          lockedNote: _ctx.isTaskManager ? 'Owner' : 'Creator',
          onSave: _ctx.saveUsers,
          onClose: _cache[48] || (_cache[48] = () => { _ctx.showEditUsers = false; })
        }, null, 8, ["selectedIds", "lockedIds", "lockedNote", "onSave"]))
      : _createCommentVNode("", true),
    (_ctx.showScorecard)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 10,
          url: '/scoreboard?hideNav=t&hideChat=t',
          onClose: _cache[49] || (_cache[49] = () => { _ctx.showScorecard = false })
        }))
      : _createCommentVNode("", true),
    (_ctx.showRocks)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 11,
          url: '/scoreboard?view=rocks&hideNav=t&hideChat=t',
          onClose: _cache[50] || (_cache[50] = () => { _ctx.showRocks = false })
        }))
      : _createCommentVNode("", true),
    (_ctx.showGoals)
      ? (_openBlock(), _createBlock(_component_pdf_pop_up, {
          key: 12,
          url: '/scoreboard?view=goals&hideNav=t&hideChat=t',
          onClose: _cache[51] || (_cache[51] = () => { _ctx.showGoals = false })
        }))
      : _createCommentVNode("", true),
    (_ctx.rockCard)
      ? (_openBlock(), _createBlock(_component_rock_modal, {
          key: 13,
          rock: _ctx.rockCard.rock,
          quarter: _ctx.rockCard.rock.Quarter,
          employees: _ctx.rockCard.employees,
          teams: _ctx.rockCard.teams,
          myEmployeeID: _ctx.rockCard.myEmployeeID,
          "on-board": !!_ctx.rockCard.card,
          "add-columns": _ctx.rockCard.card ? null : _ctx.columnNames,
          "add-column": _ctx.addRockColumn,
          onClose: _cache[52] || (_cache[52] = ($event: any) => (_ctx.closeRockCard())),
          onSaved: _ctx.rockCardSaved,
          onRemoveFromBoard: _cache[53] || (_cache[53] = ($event: any) => (_ctx.removeRockCard())),
          onAddToBoard: _ctx.addInboxRockToBoard
        }, null, 8, ["rock", "quarter", "employees", "teams", "myEmployeeID", "on-board", "add-columns", "add-column", "onSaved", "onAddToBoard"]))
      : _createCommentVNode("", true)
  ]))
}